import { CButton, CCard, CCardBody, CCardImage, CCardText, CCol, CRow } from '@coreui/react';
import { Link } from 'react-router-dom';

const Cards = ({ items, cols }) => {

  const buttonStyle = {

    backgroundColor: 'var(--primary-color)',
    paddingVertical: 15,
    paddingHorizontal: 50,
    borderRadius: 25,
    alignItems: 'center',
    marginBottom: 10,

  }
  const linkStyle = {
    textDecoration: 'none',
  }


  return (

    <CRow className='align-items-stretch' xs={{ cols: 1, gutter: 4 }} md={{ cols: cols }}>
      {items?.map((item, index) => (
        <CCol key={index}>

          <CCard className='hst-card h-100 shadow-lg' style={{borderRadius: "15px"}}>
            <CCardImage orientation="top" src={item.image} style={{ height: '100%',  borderRadius: '15px 15px 0 0'}} />
            <CCardBody className='d-flex flex-column justify-content-end' style={{borderRadius: '0 0 15px 15px'}}>
              <CCardText className='fs-3' style={{ fontWeight: "bold", cursor: "default" }}>{item.title}</CCardText>
              <CCardText style={{cursor: "default"}}>{item.text}</CCardText>
              <Link className='d-block text-center mt-4' style={linkStyle} to={item.to}>
                <CButton style={buttonStyle} className='text-center text-uppercase text-white pe-4 ps-4'>{item.name}</CButton>
              </Link>
            </CCardBody>
          </CCard>
        </CCol>
      ))}
    </CRow>

  );
}

export default Cards;